import { apiSlice, TICKDATA_BASE_URL } from './apiSlice';

export const tickdataApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /** Tick candles for one symbol. Answers `{ candles: [{ time, open, high, low, close }] }`. */
    getCandles: builder.query({
      query: ({ symbol, ...body }) => ({
        url: `${TICKDATA_BASE_URL}/api/symbol/${encodeURIComponent(symbol)}`,
        method: 'POST',
        body,
        credentials: 'omit',
      }),
      providesTags: ['Trade'],
    }),
  }),
});

export const { useGetCandlesQuery } = tickdataApi;
